import { useNavigate } from "react-router";
import { capitalizeFirstLetter } from "../../../replace_str_constant";
import {
  MdKeyboardArrowRight,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import LazyImage from "../../../components/Loading/lazyImage";
import { CURRENCY_SYMBOL } from "../../../constant";

const SelectMethod = ({
  method,
  currency,
  setChooseCurrency,
  setDepositStep,
  min,
  max,
  isVip,
  isCrypto,
}) => {
  const navigate = useNavigate();

  return (
    <section
      onClick={() => {
        setChooseCurrency(currency);
        navigate(
          `?method=${method}&min=${min}&max=${max}&isCrypto=${
            isCrypto ? "1" : "0"
          }`
        );
        setDepositStep(2);
      }}
      className="flex items-center justify-between bg-transaction-card dark:bg-base-light-dark hover:bg-hover-transaction-card rounded-xl p-[12px] mb-[10px] cursor-pointer"
    >
      <div className="flex gap-[20px] items-center justify-start">
        <div>
          <LazyImage
            src={`https://gamepics.91url.cc/bankIcon/${method?.toLowerCase()}.png?123123`}
            className="!w-[45px] !h-[45px] object-cover"
            loadingClassName=""
          />
        </div>
        <div className="flex flex-col gap-[10px]">
          <p className="text-transaction-text dark:text-base-light-white font-semibold mb-0">
            {capitalizeFirstLetter(method)}
            &nbsp;
            {`(${currency})`}
            {isVip && (
              <span className="ml-[5px] bg-gold-text text-xs rounded-full px-[7px] py-[1px]">
                VIP
              </span>
            )}
          </p>
          <p className="text-light-gray text-sm mb-0">
            {min || max ? (
              `${min} ${CURRENCY_SYMBOL} - ${max} ${CURRENCY_SYMBOL}`
            ) : (
              <div>&nbsp;</div>
            )}
          </p>
        </div>
      </div>
      <MdKeyboardArrowRight className="text-xl font-semibold text-transaction-text dark:text-base-light-white" />
    </section>
  );
};

export default SelectMethod;
